module.exports = __webpack_public_path__ + "img/super-bundle-27.998d4f3.webp";